import React from 'react'
import burgerToCross from '../json/burger-to-cross.json'
// import burgerHover from '../json/burger-hover.json'
import Lottie from 'lottie-web'
import Superface from '../Superface'

import { withRouter } from 'react-router'

class Burger extends React.Component{
    
    options = {
        renderer: 'svg',
        loop: false,
        autoplay: false,
        // animationData : milanAnimation
    }
    isHoverPlaying = false

    componentWillMount(){
        this.setState({
            ...this.state, hover : false, mounted : false
        })
        // this.setState({mounted : false})
    }
    
    // componentDidMount(){
    //     this.burger_to_cross.goToAndStop(0)
    //     this.burger_hover.goToAndPlay(0)
    //     // this.setState({mounted : true})
    // }
    // direction = -1
    // componentDidMount(){
        
    // }

    componentWillReceiveProps(new_props){
        // console.log(' THIS.PROPS.OPEN : ', this.props.open)
        if( new_props.open !== this.props.open ){
            // alert('sisi')
            if(new_props.open){
                // alert('sisi')
                // this.burger_to_cross.seek(0)
                // this.cross_to_burger.goToAndPlay(0)
                // alert('open')
                // this.burger_to_cross.pause()
                this.burger_to_cross.pause()
                this.burger_to_cross.setDirection(1)
                this.burger_to_cross.goToAndPlay(0)
            }else{
                this.burger_to_cross.pause()
                this.burger_to_cross.setDirection(-1)
                this.burger_to_cross.play()
                // alert('close')
                // this.burger_to_cross.seek(0)

            }
        }
    }

    componentDidMount(){
        this.burger_to_cross = Lottie.loadAnimation( {...this.options, container : this.container, animationData : burgerToCross } )
        // this.burger_hover = Lottie.loadAnimation( {...this.options, container : this.containerHover, animationData : burgerHover } )
        if(this.props.open){
            this.burger_to_cross.pause()
            this.burger_to_cross.setDirection(1)
            this.burger_to_cross.goToAndPlay(0)
        }
        this.timeoutMount = setTimeout( () => {
            this.setState({
                ...this.state, mounted : true
            }) 
        }, 600)
    }

    onMouseEnter(){
        this.setState({
            ...this.state, hover : true
        })
        // this.burger_hover.goToAndPlay(0)
    }

    onMouseLeave(){
        this.setState({
            ...this.state, hover : false
        })
    }

    handleClick(){
        if( Superface.app().isOnSingle ){
            Superface.singleLeaving(true)
            setTimeout( () => {
                Superface.goTo( Superface.uri(Superface.app().currentSection) )
                Superface.singleLeaving(false)
            }, 600)
        }else{
            Superface.toggleMenu();
        }
    }

    render(){
        
        const { open } = this.props
        const style = { cursor:'pointer', width : '2rem', position:'fixed', zIndex:2000, right:'2rem', top:'2.5rem' }
        
        // display : open ? 'block' : 'none'
        return(
            <div id="burger" className={this.state.mounted ? 'mounted' : ''} style={style} 
                onMouseEnter={(e) => { this.onMouseEnter(e) }} 
                onMouseLeave={ (e) => { this.onMouseLeave(e) }}
                onClick={ (e) => { this.handleClick(e) }}
                >
                <div style={{ display : open ? 'block' : 'none' }}  ref={ container => { this.container = container }}></div>
                <div id="burger-strokes" className={(this.state.hover ? 'hover' : '' )} style={{ display : open ? 'none' : 'block' }}>
                    <span>
                        <span></span>
                        <span></span>
                    </span>
                    <span>
                        <span></span>
                        <span></span>
                    </span>
                    <span>
                        <span></span>
                        <span></span>
                    </span>
                    
                </div>
            </div>
        )
        
    }
}

export default withRouter(Burger)


// WEBPACK FOOTER //
// ./src/components/_Burger.js